import { render } from "./designReferenceForm.vue?vue&type=template&id=2f2f523e"
import script from "./designReferenceForm.vue?vue&type=script&lang=js"
export * from "./designReferenceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__